import { useContext } from 'react';

import {
  ChipGroupContext,
  type ChipGroupContextProps,
} from '../contexts/ChipGroupContext.js';

/**
 * Hook for accessing the ChipGroupContext.
 * @public
 */
export const useChipGroupContext = (): ChipGroupContextProps =>
  useContext(ChipGroupContext);
